import React from 'react';
import { navigate } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { useLocaleMismatch } from '@/hooks/use-locale-mismatch';
import { usePageContext } from '@/context/page-context';
import { CountriesEnum } from '@/enums/countries';
import { formatUrl } from '@/utils/url';
import Dialog from '@/components/elements/dialog';
import LocaleMismatchModal from './locale-mismatch-modal';

function LocaleMismatchChecker() {
	const { showModal, suggestedLocale, currentLocale, handleDismissModal } = useLocaleMismatch();
	const { localizations } = usePageContext();
	const { t } = useTranslation();

	if (!showModal || !suggestedLocale) {
		return null;
	}

	const currentCountry = CountriesEnum.find(c => c.locale === currentLocale);

	const handleSelectSuggested = () => {
		handleDismissModal();
		const localization = localizations?.find(c => c.locale === suggestedLocale.locale);
		if (localization) {
			navigate(formatUrl(localization.full_slug));
		} else {
			navigate(`/${suggestedLocale.locale}`);
		}
	};

	// Vlaanderen en Nederland are two separate regions with the same language; so we prefer the region name
	// Other (Global) languages are not tied to specific country/region, so they use the 'international'
	// language name.
	const suggestedLocaleName = suggestedLocale.regionName || suggestedLocale.languageName;
	const currentLocaleName = currentCountry?.regionName || currentCountry?.languageName || currentLocale;

	return (
		<Dialog open={showModal} onClose={handleDismissModal} maxWidth="640px">
			<LocaleMismatchModal
				title={t('gynzy-com.locale-mismatch.title')}
				bodyText={t('gynzy-com.locale-mismatch.body', {
					suggestedName: suggestedLocaleName,
				})}
				suggestedLabel={suggestedLocaleName}
				currentLabel={currentLocaleName}
				onSelectSuggested={handleSelectSuggested}
				onDismiss={handleDismissModal}
			/>
		</Dialog>
	);
}

export default LocaleMismatchChecker;
